<template>
  <div>
    <!-- <div class="title">
      <span>发起人:{{ voteResult.voteName }}</span>
      <span v-if="vo !== null" style="margin-left:20px">截止时间：{{ vo.endTime }}</span>
    </div> -->
    <div class="content">
      <template v-if="vo !== null">
        <ul v-for="(item,index) in vo.passenger.subjects" :key="index">
          <p class="subject">{{ index+1 }}、{{ item.subject }} ({{ voteTypeArr[item.voteType-1] }})</p>
          <el-radio-group v-if="item.voteType === 1" v-model="item.checkedValue" :disabled="canEdit === 'no'" class="widthall">
            <li v-for="(choice, _index) in item.passenger.choices" :key="_index" class="opiton" :checked="choice.checked">
              <el-radio :label="choice.id">{{ choice.subject }}</el-radio>
              <img v-if="choice.coverUrl !== null" class="img-box" :src="base_api+'/hygl/vote/download?dataField=voteFile&nameField=voteFileName&id='+ choice.id" style="margin-bottom:10px">
            </li>
          </el-radio-group>
          <el-checkbox-group v-if="item.voteType === 2" v-model="item.checkedValue" :disabled="canEdit === 'no'" class="widthall">
            <li v-for="(choice, _index) in item.passenger.choices" :key="_index" class="opiton" :checked="choice.checked">
              <el-checkbox :label="choice.id">{{ choice.subject }}</el-checkbox>
              <img v-if="choice.coverUrl !== null" class="img-box" :src="base_api+'/hygl/vote/download?dataField=voteFile&nameField=voteFileName&id='+ choice.id" style="margin-bottom:10px">
            </li>
          </el-checkbox-group>
        </ul>
      </template>
    </div>
    <div class="footer">
      <el-button v-if="voteResult.choiceStatus === 1 || canEdit === 'yes'" v-text-lbl="'hygl.voteManage.submitwj'" type="primary" @click="submitVoteResInfo">提交问卷</el-button>
    </div>
  </div>
</template>
<script>
const { uuid } = require('@/global/utils/index.js')
export default {
    components: {

    },
    props: {

    },
    data() {
        return {
            base_api: process.env.VUE_APP_BASE_API,
            dialogVisibleParticipate: false,
            // voteTypeArr: ['单选', '多选'],
            voteTypeArr: [this.$tx('hygl.voteManage.Radio', '单选'), this.$tx('hygl.voteManage.multipleChoice', '多选')],

            id: '',
            account: '',
            orgCode: '',
            voteResult: {},
            vo: null,
            myChoiceList: {},
            choiceTotle: 0,
            canEdit: null
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
        this.id = this.$route.query.id
        this.account = this.$route.query.account
        this.orgCode = this.$route.query.orgCode
        this.canEdit = this.$route.query.canEdit
        this.resultId = this.$route.query.resultId
        this.getVoteResult()
    },
    methods: {
        // 查询投票结果
        getVoteResult() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: '/hygl/voteResult/getById',
                params: { id: this.resultId }
            }).then(res => {
                if (res.code === 'success') {
                    // debugger
                    this.voteResult = res.body.vo
                    this.getByIdFunc()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 获取问卷详情
         */
        getByIdFunc() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                url: 'hygl/vote/getById',
                params: { id: this.id }
            }).then(res => {
                if (res.code === 'success') {
                    const vo = res.body.vo
                    // 遍历题目
                    vo.passenger.subjects.forEach(subject => {
                        // 题目的选项答案
                        subject.checkedValue = subject.voteType === 1 ? '' : []
                        // 已投票
                        if (this.voteResult.choiceStatus === 2) {
                            // 问卷已选项遍历
                            this.voteResult.passenger.voteResultInfos.forEach(resultInfo => {
                                // 选项的题目id和题目id相等  选项类型相等
                                if (subject.id === resultInfo.subjectId && resultInfo.voteType === 1) {
                                    subject.checkedValue = resultInfo.choiceId
                                } else if (subject.id === resultInfo.subjectId && resultInfo.voteType === 2) {
                                    subject.checkedValue.push(resultInfo.choiceId)
                                }
                            })
                        }
                    })
                    this.vo = vo
                    this.$forceUpdate()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
         * 进行投票
         */
        submitVoteResInfo() {
            // 投票校验
            let canSubmit
            this.vo.passenger.subjects.forEach((item) => {
                if (item.voteType === 1 && item.checkedValue === '') {
                    canSubmit = true
                } else if (item.voteType === 2 && item.checkedValue.length === 0) {
                    canSubmit = true
                }
            })
            if (canSubmit) {
                this.$confirm('还有题目未选择！', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {})
                return
            }
            this.voteResult.choiceStatus = 2

            this.voteResult.passenger.voteResultInfos = []

            this.vo.passenger.subjects.forEach(item => {
                item.passenger.choices.forEach(data => {
                    if (item.checkedValue.toString().indexOf(data.id) !== -1) {
                        const voteResultInfosObj = {
                            id: uuid(),
                            resultId: this.voteResult.id,
                            subjectId: item.id,
                            subjectName: item.subject,
                            voteType: item.voteType,
                            choiceId: data.id,
                            choiceName: data.subject,
                            status: 1
                        }
                        this.voteResult.passenger.voteResultInfos.push(voteResultInfosObj)
                    }
                })
            })
            // // 更新用户是否投票的状态
            this.$http({
                method: 'PUT',
                contentType: 'application/x-www-form-urlencoded',
                data: this.voteResult,
                url: 'hygl/voteResult/update'
            }).then(res => {
                if (res.code === 'success') {
                    this.$alert('您已完成问卷', this.$tx('common.operationTip', '操作提示'), { type: 'success' }).then(() => {
                        const btnRefresh = window.opener.document.querySelector('.el-icon-refresh')
                        if (btnRefresh !== null) btnRefresh.parentElement.click()
                        // 暂时隐藏
                        setTimeout(() => {
                            window.close()
                        }, 1000)
                    })
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.title{
    text-align: center;
    width: 100%;
}
.content{
    margin-top: 40px;
    ul li{
        list-style: none;
    }
    .subject{
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }
    .opiton{
        padding-left: 16px;
        font-size: var(--portalFontSize14);
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        // margin-bottom: 20px;
        .img-box{
            width: 270px;
           height: 160px;
            display: block;
        }
    }
    .true-box{
        position: absolute;
        top: calc(50% - 14px);
        right: 20px;
    }
    /deep/ .el-checkbox-group{
        .el-checkbox__label{
            color:#606266;
        }
    }
    /deep/ .el-radio-group {
        .el-radio__label{
            color:#606266;
        }
    }
}
.footer{
    margin-top: 30px;
    text-align: center;
    /deep/ .el-button--primary{
        width: 220px;
        height: 40px;
        font-size: var(--portalFontSize14);
        font-weight: bold;
    }
}
</style>
